
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

import SettingsGroup from '../../../views/Settings/Group/index.vue'
import SettingsItem from '../../../views/Settings/Item/index.vue'
import SettingsSwitch from '../../../views/Settings/Switch/index.vue'
import { Bind, Debounce } from 'lodash-decorators'

import type { NotificationConfig } from '@xt/client/entities/my-v2/settings-notice'

@Observer
@Component({
  components: {
    SettingsGroup,
    SettingsItem,
    SettingsSwitch
  }
})
export default class MySettingsNotice extends Vue {
  get PageStore() {
    return this.$store.$myV2.Settings.Notice
  }

  @Debounce(500, { leading: true, trailing: false })
  @Bind()
  async handleClickItem(item: NotificationConfig) {
    const isSuccess = await this.PageStore.onChangeNoticeSettings(item)

    if (isSuccess) {
      this.$message.success('设置成功')
    }
  }

  created() {
    this.PageStore.loadNoticeSettings()
  }
  mounted() {}
  updated() {}
  destroyed() {
    this.PageStore.reset()
  }
}
